/* unplugin-vue-components disabled */import { render } from "./order.vue?vue&type=template&id=6a90e56c"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=6a90e56c&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__